import { yup } from '@framework/validation/initYup.ts';
import { CiComputedStringGear } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema.ts';
import { CommonComputedWidgetConfigComponent } from '../CommonComputedWidgetConfigComponent.tsx';
import { CommonComputedWidgetPreview } from '../CommonComputedWidgetPreview.tsx';
import { type IComputedStringWidget } from '../IComputedWidget.ts';
import { ComputedStringConfigSchema } from './ComputedStringConfigSchema.ts';
import { ComputedStringWidgetComponent } from './ComputedStringWidgetComponent.tsx';
import { setComputeStringTransform } from './setComputedStringTransform.ts';

export const ComputedStringWidgetType: IWidgetType<IComputedStringWidget> = {
  type: WidgetType.ComputedString,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.String),
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputeStringTransform(
        widget,
        parentScope,
        yup.string().notRequired(),
      ),
      widget,
    );
  },
  name: 'Testo Calcolato',
  icon: <CiComputedStringGear />,
  rules: [],
  formComponent: ComputedStringWidgetComponent,
  configComponent: CommonComputedWidgetConfigComponent,
  configValidator: ComputedStringConfigSchema,
  previewComponent: CommonComputedWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  alwaysEnabled: true,
};
